import React, { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import MenuBotones from "../../MenuBotones";

function BotonesCompras() {
  const { user } = useContext(AuthContext);

  const secciones = [
    { section: "Compras", items: [
      { label: "Ordenes de Compra", icon: "fas fa-shopping-basket", color: "#2563eb", href: "/ListadoOrdenesCompra", enabled: !!(user.menu_compras && user.menu_oc) },
      { label: "Recepción", icon: "fas fa-cart-plus", color: "#2563eb", href: "/ListadoCompras", enabled: !!(user.menu_compras) },
      { label: "Devoluciones", icon: "fas fa-undo-alt", color: "#2563eb", href: "/ListadoDevolucionesProveedores", enabled: !!(user.menu_compras && user.menu_devolucionesProveedores) },
    ]},
    { section: "Reportes", items: [
      { label: "Corte Diario", icon: "fas fa-cut", color: "#7c3aed", href: "/CorteDiario", enabled: !!(user.menu_compras) },
      { label: "Reporte Telas", icon: "fas fa-scroll", color: "#7c3aed", href: "/ReporteTelas", enabled: !!(user.menu_compras && (user.menu_produccion || user.menu_compras)) },
      { label: "Reporte Compras Material", icon: "fas fa-cart-plus", color: "#7c3aed", href: "/ReporteComprasMaterial", enabled: !!(user.menu_compras) },
    ]},
  ];

  return (
    <MenuBotones
      titulo="Compras"
      descripcion="Órdenes de compra, recepción y reportes"
      icono="fas fa-shopping-basket"
      color="#2563eb"
      secciones={secciones}
    />
  );
}

export default BotonesCompras;
